
export default {
  name: 'UserAgreement',
  layout: 'default',
  head() {
    return {
      title: 'XPPen User Agreement',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'XPPen Community User Agreement — terms for registering and using XPPen Account and Services.',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'XPPen, User Agreement, Terms of Service, Community',
        },
      ],
    }
  },
  mounted() {
    if (!process.client) return
    try {
      const header = document.querySelector('header')
      const footer = document.querySelector('footer')
      if (header) header.style.display = 'none'
      if (footer) footer.style.display = 'none'
    } catch (e) {}
  },
}
